export type CanonicalLessonDraft = {
    id: string;
    title: string;
    content: string;
    sourceLessonId?: number;
};

export type ModuleDraft = {
    id: string;
    title: string;
    lessons: CanonicalLessonDraft[];
    sourceModuleId?: number;
};

export type LevelDraft = {
    id: string;
    name: string;
    modules: ModuleDraft[];
    sourceLevelId?: number;
};

export type OrganizationOption = {
    id: number;
    name: string;
};

export type PromptDraft = {
    generation_prompt: string;
    proactive_prompt: string;
    quiz_prompt: string;
    placement_quiz_prompt: string;
    remedial_lesson_prompt: string;
};

export const getJsonError = (value: string): string | null => {
    const trimmed = value.trim();
    if (!trimmed) return null;
    try {
        JSON.parse(trimmed);
        return null;
    } catch {
        return "Lesson text must be valid JSON.";
    }
};
